<template>
  <main class="customer_join main">
    <div class="join_inner">
      <div class="text_area">
        <h2>성별이<br />어떻게 되시나요?</h2>
        <p>
          <span>딱 맞는 상품 추천</span>을 위해 <span>5초</span>만 내어주세요!
        </p>
      </div>
      <div class="join_gender">
        <button @click="genderSel('MALE')">
          <img src="@/assets/front/images/v2/etc/img_login_boy.png" />
          <span>남성</span>
        </button>
        <button @click="genderSel('FEMALE')">
          <img src="@/assets/front/images/v2/etc/img_login_girl.png" />
          <span>여성</span>
        </button>
      </div>
    </div>
  </main>
</template>
<script>
export default {
  name: 'JoinGender',
  components: {},
  data() {
    return {};
  },
  created() {},
  async mounted() {},
  computed: {},
  methods: {
    genderSel(gender) {
      localStorage.setItem('join_gender', gender);

      this.$router.push({
        name: 'Auth.JoinAge',
      });
    },
  },
};
</script>
